import { BaseController } from './BaseViewUI/BaseController';

/**
 * BaseFragmentController
 *
 * BaseFragmentに対応する形のベースコントローラー
 */
export class BaseFragmentController extends BaseController {

	// BaseControllerの継承関係はBaseViewでインスタンス化され、
	// 対応するコンポーネントのインスタンスはBaseViewでBaseControllerのプロパティに設定される。

	// コンポーネントとコントローラーの結合用プロパティは、継承関係上の上書きする。
	// F12での参照が出来うようにする為と、クラス構造で、どのViewと紐づくか明示する為。
	public combineView: any;



}
